/*******************************************************************************
 * Project：
 * Summary:
 *　　 App Reducers
 * Remarks:
 *    Define Reducers for app
 * History：
 *    CuongLD            2021/05/31    Create
 *    QuangTN            2021/06/10    Update
 *    TrungTT            2021/07/01    Add staff reducer
 ******************************************************************************/

import { ActionReducerMap } from '@ngrx/store';
import { IAppState } from '../states/app.state';
import { userReducers } from './user.reducers';
import { loadingReducers } from './loading.reducers';
import { mstHTOrgReducers } from './mstHTOrg.reducer';

export const appReducers: ActionReducerMap<IAppState, any> = {
  users: userReducers,
  loading: loadingReducers,
  mstHTOrg: mstHTOrgReducers,
};
